export default __webpack_public_path__ + "static/media/640_dummy2016-goldschmiede01-mobile-de.ff918b03.png";